import {Component, OnInit, AfterViewInit} from '@angular/core';
import { Router, NavigationEnd, Route } from '@angular/router';

//services
import { InformationService} from '../services/information.service';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css'],
    providers: [ InformationService ]
})
export class ProjectComponent implements OnInit{
    welcome : string;
    subtitle : string;
    projects: any[] = [];
    router : Router;

    constructor(private informationService: InformationService, router: Router){
        this.welcome = "What I have done?";
        this.subtitle = "Some of the interesting projects and works done surprisingly by me!";
        this.router = router;
    }

    ngOnInit() {
        this.informationService.getProjects().subscribe(response => {this.projects = response.json()});
        
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
            setTimeout(() => {
            const element = document.querySelector("#" + tree.fragment);
            if (element) { element.scrollIntoView(); }}, 300);
        }
    }

};